import $ from 'jquery'; // Import jQuery (assuming it's installed via npm or CDN)

const handleScroll = () => {
    const hash = window.location.hash.substring(1);  // Get the hash without the #
    if (hash) {
        const element = document.getElementById(hash);
        if (element) {
            // Use scrollIntoView for smooth scrolling
            element.scrollIntoView({
                behavior: 'smooth',  // Smooth scrolling effect
                block: 'start'       // Scroll to the top of the element
            });
            /* window.setTimeout(() => {
                window.scrollBy({
                    top: -100,  // Scroll 200px higher
                    behavior: 'smooth'  // Smooth scroll for the adjustment
                });
            }, 400); */
        }
    }
};

// Function to scroll to a specific element with an offset
function scrollToElement(elementId, offset) {
    var element = $('#' + elementId)[0];

    if (element) {
        var elementPosition = element.getBoundingClientRect().top + window.scrollY;
        var offsetPosition = elementPosition - offset;

        $('html, body').animate({
            scrollTop: offsetPosition
        }, 250);
    }
}

export { handleScroll };



